import { createSlice } from '@reduxjs/toolkit'
import { initialState, listReducers } from './listConstants'

const unassignedContactsListSlice = createSlice({
    name: 'ui/unassigned-contacts-list',
    initialState: {
        ...initialState,
        filters: { ...initialState.filters, userType: 'all' },
        pureFilters: { ...initialState.pureFilters, userType: 'all' },
        populates: [
            { path: 'country', select: 'name' },
            { path: 'city', select: 'name' }
        ]
    },
    reducers: {
        ...listReducers,
        onResetFilters(state) {
            state.filters = { userType: 'all' }
            state.pureFilters = { userType: 'all' }
        }
    }
})

export const unassignedContactsListActions = unassignedContactsListSlice.actions
export default unassignedContactsListSlice.reducer
